import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let searchQueryParamsProject = new URLSearchParams(searchOptions).toString();
  let searchQueryEmployeeDepartment = new URLSearchParams(searchOptions).toString();

  let searchSaleBlockQueryParams = searchQueryParams;
  if (saleAreaId)
    searchSaleBlockQueryParams =
      searchQueryParams + "&" + new URLSearchParams({ saleAreaId }).toString();
  if (projectId)
    searchQueryParamsProject =
      searchQueryParams + "&" + new URLSearchParams({ projectId }).toString() ;
  if(department){
    searchQueryEmployeeDepartment =
      searchQueryParams + "&" + new URLSearchParams({ department }).toString() ;
  }

  let searchSaleOpeningEventParams = searchQueryParams;
  if (projectId)
    searchSaleOpeningEventParams =
      searchQueryParams + "&" + new URLSearchParams({ projectId }).toString();

  // Fetch constant data concurrently
  const [
    project,
    apartmentType,
    division,
    property,
    direction,
    saleOpeningEvent,
  ] = await Promise.all([
    clientAPI("get", `/project?${searchQueryParams}`),
    clientAPI("get", `/apartmentType?${searchQueryParams}`),
    clientAPI("get", `/division?${searchQueryParamsProject}`),
    clientAPI("get", `/property?${searchQueryParams}`),
    clientAPI("get", `/direction?${searchQueryParams}`),
    clientAPI("get", `/saleOpeningEvent?${searchSaleOpeningEventParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    apartmentType: apartmentType?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    division: division?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    property: property?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    direction: direction?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleOpeningEvent: saleOpeningEvent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(saleAreaId, projectId, department, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories1", saleAreaId, projectId, department],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
